import { render, staticRenderFns } from "./ListagemOcorrencias.vue?vue&type=template&id=4318adad&scoped=true"
import script from "./ListagemOcorrencias.vue?vue&type=script&lang=js"
export * from "./ListagemOcorrencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318adad",
  null
  
)

export default component.exports